import BaseService from '@root/core/class/BaseService';
import {
  IExportQueryParams,
  IQueryParams
} from '@root/modules/Sellers/Product/interfaces';

class buskService extends BaseService {
  public getSellerDetail = (id: string) => {
    return this.get(`/sellers/${id}`);
  };
  public getWarehouseList = (id: string, page: any) => {
    return this.get(`/sellers/${id}/warehouses?page=${page}&limit=10`);
  };
  public getProductList = (id: string, page: any) => {
    return this.get(`/sellers/${id}/products?page=${page}&limit=10`);
  };

  public getOrderList = (id: string, query: IQueryParams) => {
    const searchParams = this.assigneQueryParams(query);
    return this.get(`/orders/${id}?${searchParams}`);
  };

  public ApproveSellerSignup = (id: string) => {
    return this.post(`/sellers/${id}/approve`);
  };
  public ApproveSellerAmendment = (id: string) => {
    return this.post(`/sellers/${id}/approveAmendment`);
  };

  public RejectSellerSignup = (id: string) => {
    return this.post(`/sellers/${id}/reject`);
  };
  public RejectSellerAmendment = (id: string) => {
    return this.post(`/sellers/${id}/rejectAmendment`);
  };

  public exportSellerExcellOrder = (id: string, query: IExportQueryParams) => {
    if (query.listId && query.listId.length) {
      query = {
        sortBy: query.sortBy,
        ids: query.listId
      };
    } else {
      delete query.listId;
    }

    const searchParams = this.assigneQueryParams(query);
    return this.post(
      `/orders/${id}/export?${searchParams}`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportSellerExcellWarehouse = (id: string) => {
    return this.post(
      `/sellers/${id}/warehouses/export`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
  public exportSellerExcellWarehouseById = (id: string, listId: any) => {
    return this.post(
      `/sellers/${id}/warehouses/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };
  public exportSellerExcellProduct = (id: any) => {
    return this.post(
      `/sellers/${id}/products/export`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
  public exportSellerExcellProductById = (id: any, listId: any) => {
    return this.post(
      `/sellers/${id}/products/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public getReturns = (id: string, query: IQueryParams) => {
    const searchParams = this.assigneQueryParams(query);

    const url = `/sellers/${id}/return?${searchParams}`;
    return this.get(url);
  };

  public returnExportExcel = (id: string, query: IExportQueryParams) => {
    query = {
      ...query,
      ids: query.listId
    };
      delete query.listId;

    const searchParams = this.assigneQueryParams(query);
    const url = `/sellers/${id}/return/excel?${searchParams}`;
    return this.get(
      url,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportAll = (id: string) => {
    return this.post(
      `/sellers/${id}/excel-all`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public getIntergrationHistory = (query: IQueryParams) => {
    const searchParams = this.assigneQueryParams(query);

    const url = `/sellers/${query.id}/market-integration-histories?${searchParams}`;
    return this.get(url);
  }
}

export default new buskService('/api/v1/admin', true);
